import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Marquee from "@/components/Marquee";
import Reveal from "@/components/motion/Reveal";
import { scrollToId } from "@/components/SmoothScroll";
import Hero from "@/components/sections/Hero";
import TrustBar from "@/components/sections/TrustBar";
import Features from "@/components/sections/Features";
import HowItWorks from "@/components/sections/HowItWorks";
import KidsSection from "@/components/sections/KidsSection";
import Testimonials from "@/components/sections/Testimonials";
import Pricing from "@/components/sections/Pricing";
import FAQ from "@/components/sections/FAQ";
import Closing from "@/components/sections/Closing";

export default function Landing() {
  const buy = () => scrollToId("precios");

  return (
    <div className="bg-[#F3F2F2]" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero onBuy={buy} onHow={() => scrollToId("como-funciona")} />
        <TrustBar />
        <Marquee
          items={["Siempre cerca", "Libertad para explorar", "Sin redes sociales", "Batería de 3 días", "Tranquilidad real"]}
          bg="#12263A"
          color="#F3F2F2"
        />
        <Features />
        <HowItWorks />
        <KidsSection />
        <Reveal><Testimonials /></Reveal>
        <Pricing />
        <Reveal><FAQ /></Reveal>
        <Closing onBuy={buy} />
      </main>
      <Footer />
    </div>
  );
}
